import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen text-center" }
const _hoisted_3 = { class: "bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "bg-gray-50 p-4 rounded-md" }
const _hoisted_8 = { class: "space-y-2 max-h-[40vh] overflow-y-auto" }
const _hoisted_9 = { class: "text-sm flex-1" }
const _hoisted_10 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_11 = { class: "bg-gray-50 p-4 rounded-md" }
const _hoisted_12 = { class: "space-y-2 max-h-[30vh] overflow-y-auto" }
const _hoisted_13 = { class: "flex-1 mr-2" }
const _hoisted_14 = { class: "text-sm font-medium" }
const _hoisted_15 = { class: "text-xs text-gray-500" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-between" }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, " Document Types Status "),
                  _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Overview of required document types and their status ")
                ], -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex mb-2" }, [
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 flex-1" }, "Document Type"),
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 w-24 text-center mr-6" }, "Status")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypesStatus, (status, type) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: type,
                        class: _normalizeClass(["flex items-center p-2 rounded-md", status ? 'bg-green-50' : 'bg-red-50'])
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(type), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 py-1 text-xs font-medium rounded-full w-24 text-center", status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
                        }, _toDisplayString(status ? 'Available' : 'Missing'), 3)
                      ], 2))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.mergedDocuments && _ctx.mergedDocuments.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-700 mb-2" }, "Merged Documents", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mergedDocuments, (doc) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: doc.id,
                            class: "flex items-center justify-between p-2 rounded-md bg-white border border-gray-200"
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(doc.name), 1),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDate(doc.timestamp)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.downloadDocument(doc)),
                                class: "px-2 py-1 text-xs bg-primary text-white rounded hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 mr-2"
                              }, " Download ", 8, _hoisted_17),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deleteDocument(doc)),
                                class: "p-1 text-xs text-red-600 rounded hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1",
                                title: "Delete document"
                              }, _cache[8] || (_cache[8] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-4 w-4",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  })
                                ], -1)
                              ]), 8, _hoisted_18)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.showMergeAnywayButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mergeAnyway && _ctx.mergeAnyway(...args))),
                    class: "inline-flex justify-center rounded-md border border-primary shadow-sm px-4 py-2 bg-primary text-white text-base font-medium hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:text-sm"
                  }, " Merge Anyway "))
                : (_openBlock(), _createElementBlock("div", _hoisted_20)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              }, " Close ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}